import { render, staticRenderFns } from "./TerminacionActualizacion.vue?vue&type=template&id=5ea0864d&"
import script from "./TerminacionActualizacion.vue?vue&type=script&lang=js&"
export * from "./TerminacionActualizacion.vue?vue&type=script&lang=js&"
import style0 from "./TerminacionActualizacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
